var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4073 17.7533L14.9969 13.3429C16.0587 11.9293 16.6319 10.2086 16.63 8.44067C16.63 3.92473 12.9559 0.250671 8.44 0.250671C3.92406 0.250671 0.25 3.92473 0.25 8.44067C0.25 12.9566 3.92406 16.6307 8.44 16.6307C10.208 16.6326 11.9286 16.0594 13.3422 14.9975L17.7526 19.408C17.9759 19.6076 18.2671 19.7141 18.5664 19.7057C18.8658 19.6974 19.1505 19.5747 19.3623 19.363C19.574 19.1512 19.6967 18.8664 19.7051 18.5671C19.7134 18.2678 19.6069 17.9766 19.4073 17.7533ZM2.59 8.44067C2.59 7.28365 2.93309 6.15261 3.5759 5.19058C4.21871 4.22856 5.13235 3.47875 6.2013 3.03597C7.27025 2.5932 8.44649 2.47735 9.58127 2.70308C10.7161 2.9288 11.7584 3.48596 12.5766 4.30409C13.3947 5.12223 13.9519 6.1646 14.1776 7.29939C14.4033 8.43418 14.2875 9.61042 13.8447 10.6794C13.4019 11.7483 12.6521 12.662 11.6901 13.3048C10.7281 13.9476 9.59702 14.2907 8.44 14.2907C6.88905 14.2888 5.40216 13.6719 4.30548 12.5752C3.20879 11.4785 2.59186 9.99161 2.59 8.44067Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcons);
export default __webpack_public_path__ + "static/media/search_icons.79051b8ef2f0617b8cd76d3f409f9b74.svg";
export { ForwardRef as ReactComponent };